import { IconInterface } from '../interfaces/icon.interface';

const DocumentIcon = (props: IconInterface) => {
	const {
		color = '#5682FA',
		width = 23,
		height = 26,
		strokeWidth = '1.6',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="4 2 16 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14 3H6v18h12V7z"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 3v4h4"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default DocumentIcon;
